const Task = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.08337 8.25C9.08337 8.80228 8.63566 9.25 8.08337 9.25C7.53109 9.25 7.08337 8.80228 7.08337 8.25C7.08337 7.69772 7.53109 7.25 8.08337 7.25C8.63566 7.25 9.08337 7.69772 9.08337 8.25ZM10.8334 8.25C10.8334 7.83579 11.1692 7.5 11.5834 7.5H17.0834C17.4976 7.5 17.8334 7.83579 17.8334 8.25C17.8334 8.66421 17.4976 9 17.0834 9H11.5834C11.1692 9 10.8334 8.66421 10.8334 8.25ZM10.8334 12C10.8334 11.5858 11.1692 11.25 11.5834 11.25H17.0833C17.4975 11.25 17.8333 11.5858 17.8333 12C17.8333 12.4142 17.4975 12.75 17.0833 12.75H11.5834C11.1692 12.75 10.8334 12.4142 10.8334 12ZM11.5834 15C11.1692 15 10.8334 15.3358 10.8334 15.75C10.8334 16.1642 11.1692 16.5 11.5834 16.5H17.0833C17.4975 16.5 17.8333 16.1642 17.8333 15.75C17.8333 15.3358 17.4975 15 17.0833 15H11.5834ZM8.08337 13C8.63566 13 9.08337 12.5523 9.08337 12C9.08337 11.4477 8.63566 11 8.08337 11C7.53109 11 7.08337 11.4477 7.08337 12C7.08337 12.5523 7.53109 13 8.08337 13ZM9.08337 15.75C9.08337 16.3023 8.63566 16.75 8.08337 16.75C7.53109 16.75 7.08337 16.3023 7.08337 15.75C7.08337 15.1977 7.53109 14.75 8.08337 14.75C8.63566 14.75 9.08337 15.1977 9.08337 15.75ZM5.58337 3C4.34073 3 3.33337 4.00736 3.33337 5.25V18.75C3.33337 19.9926 4.34073 21 5.58337 21H19.0834C20.326 21 21.3334 19.9926 21.3334 18.75V5.25C21.3334 4.00736 20.326 3 19.0834 3H5.58337ZM4.83337 5.25C4.83337 4.83579 5.16916 4.5 5.58337 4.5H19.0834C19.4976 4.5 19.8334 4.83579 19.8334 5.25V18.75C19.8334 19.1642 19.4976 19.5 19.0834 19.5H5.58337C5.16916 19.5 4.83337 19.1642 4.83337 18.75V5.25Z"
        fill="url(#paint0_linear_338_4422)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_338_4422"
          x1="3.38119"
          y1="3"
          x2="39.5946"
          y2="11.5135"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A256BC" />
          <stop offset="1" stopColor="#F82E52" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export default Task;
